module.exports = __webpack_public_path__ + "img/step3.12c18d26.png";